module.exports = __webpack_public_path__ + "static/media/FIVE.478f90b3.png";